// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Legal Pages Styles */
.legal-page {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  color: #e8e4dc;
  line-height: 1.7;
}

.legal-page h1 {
  font-size: 32px;
  font-weight: 700;
  color: #c9a227;
  margin-bottom: 8px;
  letter-spacing: 1px;
}

.legal-page .last-updated {
  font-size: 14px;
  color: #8a8578;
  margin-bottom: 32px;
  display: block;
}

.legal-page h2 {
  font-size: 24px;
  font-weight: 600;
  color: #d4a574;
  margin-top: 40px;
  margin-bottom: 16px;
  letter-spacing: 0.5px;
}

.legal-page h3 {
  font-size: 18px;
  font-weight: 600;
  color: #d4a574;
  margin-top: 24px;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
}

.legal-page p {
  font-size: 15px;
  color: #e8e4dc;
  margin-bottom: 16px;
}

.legal-page ul {
  margin-bottom: 16px;
  padding-left: 24px;
}

.legal-page li {
  font-size: 15px;
  color: #e8e4dc;
  margin-bottom: 8px;
}

.legal-page a {
  color: #4a9c6d;
  text-decoration: none;
  transition: color 0.2s ease;
}

.legal-page a:hover {
  color: #5aac7d;
  text-decoration: underline;
}

.legal-page code {
  background: #2a2a2a;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: 13px;
  color: #c9a227;
  border: 1px solid #3a3a3a;
}

.legal-page strong {
  font-weight: 600;
  color: #f0ebe4;
}

.legal-disclaimer {
  margin-top: 48px;
  padding: 20px;
  background: linear-gradient(180deg, #2a2222 0%, #221a1a 100%);
  border-radius: 4px;
  border: 1px solid #4a3333;
}

.legal-disclaimer p {
  font-size: 13px;
  color: #c9a227;
  margin-bottom: 0;
}

/* Responsive design */
@media (max-width: 768px) {
  .legal-page {
    padding: 24px 16px;
  }

  .legal-page h1 {
    font-size: 26px;
  }

  .legal-page h2 {
    font-size: 20px;
    margin-top: 32px;
  }

  .legal-page h3 {
    font-size: 16px;
    margin-top: 20px;
  }

  .legal-page p,
  .legal-page li {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .legal-page {
    padding: 20px 12px;
  }

  .legal-page h1 {
    font-size: 22px;
  }

  .legal-page h2 {
    font-size: 18px;
    margin-top: 24px;
  }

  .legal-page h3 {
    font-size: 15px;
    margin-top: 16px;
  }

  .legal-page p,
  .legal-page li {
    font-size: 13px;
  }

  .legal-disclaimer {
    padding: 16px;
  }

  .legal-disclaimer p {
    font-size: 12px;
  }
}

/* Newsletter page */
.legal-page .newsletter-subtitle {
  font-size: 16px;
  color: #a09588;
  margin-bottom: 24px;
}

.legal-page .newsletter-form-wrapper {
  max-width: 440px;
  margin-top: 16px;
}

.legal-page .email-signup-success-back {
  margin-top: 16px;
  margin-bottom: 0;
}

`, "",{"version":3,"sources":["webpack://./src/client/styles/legal.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,4DAA4D;EAC5D,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/* Legal Pages Styles */\n.legal-page {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 40px 20px;\n  color: #e8e4dc;\n  line-height: 1.7;\n}\n\n.legal-page h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #c9a227;\n  margin-bottom: 8px;\n  letter-spacing: 1px;\n}\n\n.legal-page .last-updated {\n  font-size: 14px;\n  color: #8a8578;\n  margin-bottom: 32px;\n  display: block;\n}\n\n.legal-page h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #d4a574;\n  margin-top: 40px;\n  margin-bottom: 16px;\n  letter-spacing: 0.5px;\n}\n\n.legal-page h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #d4a574;\n  margin-top: 24px;\n  margin-bottom: 12px;\n  letter-spacing: 0.5px;\n}\n\n.legal-page p {\n  font-size: 15px;\n  color: #e8e4dc;\n  margin-bottom: 16px;\n}\n\n.legal-page ul {\n  margin-bottom: 16px;\n  padding-left: 24px;\n}\n\n.legal-page li {\n  font-size: 15px;\n  color: #e8e4dc;\n  margin-bottom: 8px;\n}\n\n.legal-page a {\n  color: #4a9c6d;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.legal-page a:hover {\n  color: #5aac7d;\n  text-decoration: underline;\n}\n\n.legal-page code {\n  background: #2a2a2a;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-family: 'Monaco', 'Consolas', monospace;\n  font-size: 13px;\n  color: #c9a227;\n  border: 1px solid #3a3a3a;\n}\n\n.legal-page strong {\n  font-weight: 600;\n  color: #f0ebe4;\n}\n\n.legal-disclaimer {\n  margin-top: 48px;\n  padding: 20px;\n  background: linear-gradient(180deg, #2a2222 0%, #221a1a 100%);\n  border-radius: 4px;\n  border: 1px solid #4a3333;\n}\n\n.legal-disclaimer p {\n  font-size: 13px;\n  color: #c9a227;\n  margin-bottom: 0;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .legal-page {\n    padding: 24px 16px;\n  }\n\n  .legal-page h1 {\n    font-size: 26px;\n  }\n\n  .legal-page h2 {\n    font-size: 20px;\n    margin-top: 32px;\n  }\n\n  .legal-page h3 {\n    font-size: 16px;\n    margin-top: 20px;\n  }\n\n  .legal-page p,\n  .legal-page li {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .legal-page {\n    padding: 20px 12px;\n  }\n\n  .legal-page h1 {\n    font-size: 22px;\n  }\n\n  .legal-page h2 {\n    font-size: 18px;\n    margin-top: 24px;\n  }\n\n  .legal-page h3 {\n    font-size: 15px;\n    margin-top: 16px;\n  }\n\n  .legal-page p,\n  .legal-page li {\n    font-size: 13px;\n  }\n\n  .legal-disclaimer {\n    padding: 16px;\n  }\n\n  .legal-disclaimer p {\n    font-size: 12px;\n  }\n}\n\n/* Newsletter page */\n.legal-page .newsletter-subtitle {\n  font-size: 16px;\n  color: #a09588;\n  margin-bottom: 24px;\n}\n\n.legal-page .newsletter-form-wrapper {\n  max-width: 440px;\n  margin-top: 16px;\n}\n\n.legal-page .email-signup-success-back {\n  margin-top: 16px;\n  margin-bottom: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
